// extracted by mini-css-extract-plugin
module.exports = {"singlepage":"styles_singlepage__1v9sr"};